// extracted by mini-css-extract-plugin
module.exports = {"EditHoursForm":"EditHoursForm_EditHoursForm__1ze0l","ButtonDarkRed":"EditHoursForm_ButtonDarkRed__2c41O","AlertDanger":"EditHoursForm_AlertDanger__3WeSD"};